import clsx from "clsx";

export interface CountProps {
  count: number;
  size?: "sm" | "base" | "lg";
  bgColor?: string;
  textColor?: string;
}

export function Count(props: CountProps) {
  const { count, size, bgColor = "bg-primary-blue", textColor="text-white" } = props;

  const sizes = {
    sm: "w-[22px] h-[22px] text-xs",
    base: "w-[32px] h-[32px] text-xs",
    lg: "sm:w-[32px] sm:h-[32px] text-xs w-[44px] h-[44px]",
  };

  const expandedSizes = {
    sm: "w-[32px] h-[32px] text-xs",
    base: "w-[32px] h-[32px] text-xs",
    lg: "sm:w-[38px] sm:h-[36px] w-[52px] h-[50px]",
  };

  if (count <= 0) {
    return null; // Return nothing if count is 0 or less
  }

  return (
    <div
      className={clsx(
        "flex items-center justify-center rounded-full font-medium",
        size && (count > 99 ? expandedSizes[size] : sizes[size]),
        bgColor, textColor
      )}
    >
      {count}
    </div>
  );
}

export default Count;
